export default __webpack_public_path__ + "static/media/Product5.1785b472.PNG";